var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamiliarSpreadsheet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 37.198 39.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6160",
    "data-name": "Group 6160",
    transform: "translate(-6 -4.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19345",
    "data-name": "Path 19345",
    d: "M14.266,9.134A4.133,4.133,0,1,0,9.1,13.122v7.522a4.133,4.133,0,0,0,0,7.977v7.522a4.133,4.133,0,1,0,2.067,0V28.621a4.133,4.133,0,0,0,0-7.977V13.122a4.133,4.133,0,0,0,3.1-3.988Zm-6.2,0A2.067,2.067,0,1,1,10.133,11.2,2.067,2.067,0,0,1,8.067,9.134Zm4.133,31a2.067,2.067,0,1,1-2.067-2.067A2.067,2.067,0,0,1,12.2,40.132Zm0-15.5a2.067,2.067,0,1,1-2.067-2.067A2.067,2.067,0,0,1,12.2,24.633Z",
    transform: "translate(0)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19346",
    "data-name": "Path 19346",
    d: "M41.8,6H18.033a1.033,1.033,0,0,0,0,2.067H41.8A1.033,1.033,0,0,0,41.8,6Z",
    transform: "translate(0.366 0.034)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19347",
    "data-name": "Path 19347",
    d: "M18.033,12.067H31.466a1.033,1.033,0,0,0,0-2.067H18.033a1.033,1.033,0,1,0,0,2.067Z",
    transform: "translate(0.366 0.167)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19348",
    "data-name": "Path 19348",
    d: "M42.832,37.033A1.033,1.033,0,0,0,41.8,36H18.033a1.033,1.033,0,0,0,0,2.067H41.8A1.033,1.033,0,0,0,42.832,37.033Z",
    transform: "translate(0.366 1.032)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19349",
    "data-name": "Path 19349",
    d: "M18.033,40a1.033,1.033,0,0,0,0,2.067H31.466a1.033,1.033,0,0,0,0-2.067Z",
    transform: "translate(0.366 1.165)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19350",
    "data-name": "Path 19350",
    d: "M41.8,21H18.033a1.033,1.033,0,0,0,0,2.067H41.8A1.033,1.033,0,1,0,41.8,21Z",
    transform: "translate(0.366 0.533)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19351",
    "data-name": "Path 19351",
    d: "M18.033,27.067H31.466a1.033,1.033,0,0,0,0-2.067H18.033a1.033,1.033,0,1,0,0,2.067Z",
    transform: "translate(0.366 0.666)",
    fill: "#f48116"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamiliarSpreadsheet);
export default __webpack_public_path__ + "static/media/FamiliarSpreadsheet.0b9baeff871c1402aa042a98ef5e849a.svg";
export { ForwardRef as ReactComponent };